<template>
    <div>
        <p :class="titleClass || titleClassDefault">{{ 'Choose language' | translation }}</p>
        <v-select
            :items="Object.values($language.getLanguages())"
            item-text="name"
            item-value="lang"
            solo
            v-model="selectedLanguage"
        ></v-select>
    </div>
</template>

<script>
    const moduleName = 'LanguageSwitcher';

    export default {
        name: moduleName,
        props: {
            titleClass: String | Array,
        },
        data(){
            return {
                selectedLanguage: null,
            };
        },
        created(){
            this.$language.waitLanguage().then(language => {
                this.selectedLanguage = language;
            });
        },
        computed: {
            titleClassDefault() {
                return this.$vuetify.breakpoint.smAndDown ? 'title' : 'display-1';
            },
        },
        watch: {
            selectedLanguage(value){
                this.$language.setLanguage(value);
            },
        },
    };
</script>